import React, { useEffect, useRef } from "react";
import { Checkbox, GetProp, Steps } from "antd";
import ItemNotificationShow from '../../../components/NotificationTemplatesManagement/ItemNotificationShow';

import './styles.scss';
import { Link } from "react-router-dom";
import useToast from "../../../hook/useToast";
import { INotificationTemplate } from "../../../api/notificationTemplate/notificationTemplateApi";

interface Props {
  className?: string;
  infoNotificationTemplate?: INotificationTemplate

  getListTemplate?: () => void
  onClose?: () => void;
  onShowHistory?: () => void;
}

const ShowNotification: React.FC<Props> = ({
  className, infoNotificationTemplate,
  onClose, onShowHistory, getListTemplate
}) => {

  const popupRef = useRef<HTMLDivElement>(null);
  const pushToast = useToast()
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
        if (onClose) {
          onClose();
        }
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [onClose]);

  const onChange: GetProp<typeof Checkbox.Group, 'onChange'> = (checkedValues: any) => {
    console.log('checked = ', checkedValues);
  };


  return (
    <div
      ref={popupRef}
      className="filter-setting show-noti w-511-px"
    >
      <div className="title-add-filter">
        <span>Mẫu nội dung</span>
      </div>

      <div className="content-filter-setting t-pl-24 t-scrollbar">
        <div className="title-content">Tóm tắt thông tin</div>
        <div className="inner-block">
          <ItemNotificationShow
            infoNotificationTemplate={infoNotificationTemplate}
            // link={'/marketing/notification-templates-management/add'}
            link={'#'}
          />
        </div>

        <div className="title-content t-mt-18">Xem trước mẫu gửi đi</div>
        <div className="inner-block">
          <div className="inner-mod">
            <div className="img-block">
              <img src="/avatar-pr.svg" alt="" />
              <div className="title">THACO AUTO</div>
            </div>
            <div className="t-px-24">
              <div className="content-block">
                <div className="border-F2F4F7 rounded-2 p-6" dangerouslySetInnerHTML={{ __html: infoNotificationTemplate?.content ?? '' }}></div>
                {/* <span>{infoNotificationTemplate?.content}</span> */}
                {/* <Link to="/">thacoauto.vn/campaign1</Link> */}
              </div>
              {/* <div className="time">3:39PM</div> */}
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default ShowNotification
